import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import Navbar from "../../../../../components/Landing_page_Navbar/index";
import "../styles/policy.css";
import defaultData from "../data/selectezi-privacy-policy.json";

// "Hello **bold** text" -> Hello <strong>bold</strong> text  (safe, no innerHTML)
const Inline = ({ text = "" }) => {
  const str = typeof text === "string" ? text : String(text || "");
  return str
    .split("**")
    .map((part, i) => (i % 2 ? <strong key={i}>{part}</strong> : part));
};

const Block = ({ b }) => {
  switch (b?.type) {
    case "h2":
      return <h2 className="policy-h2"><Inline text={b.text} /></h2>;
    case "h3":
      return <h3 className="policy-h3"><Inline text={b.text} /></h3>;
    case "h4":
      return <h4 className="policy-h4"><Inline text={b.text} /></h4>;
    case "ul":
      return (
        <ul className="policy-ul">
          {b.items?.map((item, i) => (
            <li key={i}><Inline text={item} /></li>
          ))}
        </ul>
      );
    default:
      return <p className="policy-p"><Inline text={b?.text} /></p>;
  }
};

/**
 * Global page for every legal document.
 * Usage: <PolicyPage data={privacyPolicy} />
 */
export default function PolicyPage({ data = defaultData }) {
  const content = data || defaultData;
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const updateBackToTopVisibility = () => {
      setShowBackToTop(window.scrollY > 320);
    };

    updateBackToTopVisibility();
    window.addEventListener("scroll", updateBackToTopVisibility, { passive: true });
    return () => window.removeEventListener("scroll", updateBackToTopVisibility);
  }, []);

  return (
    <div className="policy-page-wrapper">
      <Navbar />

      <main className="container py-4 py-md-5 policy">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 col-xl-8">
            <h1 className="policy-title">
              {content?.title?.map((line, i) => (
                <span key={i} className="d-block">{line}</span>
              ))}
            </h1>
            {content?.blocks?.map((b, i) => (
              <Block key={i} b={b} />
            ))}
          </div>
        </div>
      </main>

      <footer className="selectezi-footer p-3">
        <div className="container d-flex align-items-center justify-content-between flex-wrap gap-2">
          <span>
            &copy; 2025 SELECTEZI Inc. All rights reserved.
          </span>

          <div className="d-flex align-items-center gap-3">
            <Link to="/general-terms">General Terms</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </footer>

      <button
        type="button"
        className={`policy-back-to-top${showBackToTop ? " policy-back-to-top--visible" : ""}`}
        aria-label="Back to top"
        title="Back to top"
        tabIndex={showBackToTop ? 0 : -1}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <ArrowUp size={21} strokeWidth={2.2} aria-hidden="true" />
      </button>
    </div>
  );
}
